import './PrivacyPolicyViewPage.css';

const PrivacyPolicyViewPage = () => {
  return (
    <div className='privacy-page'>
      <div className='container'>
        <div className='content-box'>
          <h1 className='title'>当社の個人情報の取扱いについて</h1>
          <div className='section'>
            <p className='paragraph'>
              株式会社エフ・ディ・シィ・プロダクツ（以下「当社」）は、世界に通用する商品やサービスの提供を通じて、お客様をはじめ私たちを取り巻く人々に貢献していきます。
              そして、お客様に安心して商品やサービスをご利用いただくために、個人情報の保護及びセキュリティ対策の実施は、事業活動の基本であるとともに、社会的責務であると強く認識しております。
              当社では、役員及び従業員に個人情報保護の重要性を認識させ、個人情報の取扱いに関して以下の個人情報保護方針を定め徹底を図ります。
            </p>
          </div>

          <div className='section'>
            <h2 className='section-title center-text'>プライバシーポリシー</h2>
            <p className='paragraph'>
              お客様の個人情報の収集について
              当社は、個人情報の収集に際してその利用目的を明確にし、収集する際は適法かつ公正な手段により行います。
              なお、当社が収集するお客様の情報は、その収集方法に応じて以下のようなものとなります。
            </p>
          </div>

          <div className='section'>
            <h2 className='section-title'>■お客様からご提供いただく情報</h2>
            <ul>
              <li>氏名、生年月日、性別等プロフィールに関する情報</li>
              <li>メールアドレス、電話番号、住所等連絡先に関する情報</li>
              <li>クレジットカード情報等決済手段に関する情報</li>
              <li>
                入力フォームその他当社が定める方法を通じてお客様が入力または送信する情報
              </li>
            </ul>
          </div>

          <div className='section'>
            <h2 className='section-title'>
              ■お客様が当社のサービスをご利用されるにあたり、他のサービスとの連携を許可することにより、当該他のサービスからご提供いただく情報
            </h2>
            <ul>
              <li>当該外部サービスでお客様が利用するメールアドレス</li>
              <li>
                その他当該外部サービスのプライバシー設定によりお客様が連携先に開示を認めた情報
              </li>
            </ul>
          </div>

          <div className='section'>
            <h2 className='section-title'>
              ■お客様が当ウェブサイトを利用するにあたって、当社が収集する情報
            </h2>
            <ul>
              <li>IPアドレス、Cookie等</li>
            </ul>
          </div>

          <div className='section'>
            <h2 className='section-title'>個人情報の利用について</h2>
            <p className='paragraph'>
              収集した個人情報の利用は、利用目的の達成のために必要な範囲に限定し、ご本人の権利を損なわないよう十分配慮して行います。
              お客様の個人情報の具体的な利用目的は、別途通知又は公表するもののほか、以下のとおりです。
            </p>

            <p className='sub-title'>【お客様の個人情報】</p>
            <ul>
              <li>ご本人確認</li>
              <li>商品、請求書等の発送</li>
              <li>
                各ブランドの商品情報、イベント情報、アフターサービス及び当社の会社情報等のご案内
              </li>
              <li>システムの導入、保守等のサービスの提供</li>
              <li>
                お問合せ、ご相談、苦情、修理・サポートのご依頼等への対応及びそれらの記録
              </li>
              <li>商品及びサービスの開発及び改善</li>
              <li>
                商品及びサービスの開発及び改善、商品、サービス、キャンペーン等の広告及び情報提供並びに分析結果の販売のための属性情報、行動履歴等の分析又は提供
              </li>
              <li>
                当社の提供するサービスに関する当社の規約、ポリシー等（以下「規約等」）に違反する行為への対応（規約等に違反する利用者の発見及び当該利用者への通知、並びに、商品及びサービスを悪用した詐欺、不正アクセス等の不正行為の予防、調査、検出及び当該不正行為への対応を含みます。）
              </li>
              <li>業務上必要なご連絡、契約の履行及び商談</li>
              <li>
                ソフトウェアその他の当社の製品のサポート、販売又は宣伝に必要な範囲内での第三者への提供
              </li>
              <li>規約等の変更の通知</li>
              <li>上記各項目に記載の目的に関連する業務の遂行のため</li>
            </ul>

            <p className='sub-title'>【お取引先様の個人情報】</p>
            <ul>
              <li>注文書等の発送</li>
              <li>業務上必要なご連絡、契約の履行及び商談</li>
              <li>上記各項目に記載の目的に関連する業務の遂行のため</li>
            </ul>

            <p className='sub-title'>
              【株式会社ヨンドシーホールディングスの株主様の個人情報】
            </p>
            <ul>
              <li>
                会社法に基づく権利の行使及び義務の履行（法令に基づく記録作成等を含みます。）
              </li>
              <li>業務上必要なご連絡</li>
              <li>
                各ブランドの商品情報、イベント情報、アフターサービスならびに当社の会社情報等のご案内
              </li>
              <li>上記各項目に記載の目的に関連する業務の遂行のため</li>
            </ul>

            <p className='sub-title'>【採用・募集活動応募者様の個人情報】</p>
            <ul>
              <li>
                採用選考、応募者への当社及び採用に関する情報の通知及び提供、並びに内定者の入社前手続き
              </li>
              <li>上記記載の目的に関連する業務の遂行のため</li>
            </ul>
          </div>

          <div className='section'>
            <h2 className='section-title'>個人データの管理について</h2>
            <p className='paragraph'>
              当社は、個人データについて、漏えい、滅失又は毀損の防止等、その管理のために必要かつ適切な安全管理措置を講じます。個人データを取り扱う従業者及び委託先（再委託先及びさらにその先の委託先を含みます。）に対して、必要かつ適切な監督を行います。その他、当社の保有する個人情報の紛失、破壊、改ざん、漏えい及び不正なアクセスの防止等を含め、適切な管理のためのセキュリティシステムの維持、社内管理体制の整備等必要な措置を講じます。
            </p>
          </div>

          <div className='section'>
            <h2 className='section-title'>共同利用について</h2>
            <p className='paragraph'>
              当社は、次の範囲内で個人データを共同利用いたします。
            </p>
            <p className='mb-1'>■共同して利用される個人データの項目</p>
            <p className='paragraph'>
              ご本人から特に申入れがある場合を除いて、当社が取得した全ての個人データ
            </p>

            <p className='mb-1'>■共同して利用する者の範囲</p>
            <div className='paragraph'>
              <p>・株式会社ヨンドシーホールディングス</p>
              <p>・株式会社アスティ</p>
              <p>・株式会社エフ・ディ・シィ・フレンズ</p>
            </div>

            <p className='mb-1'>■共同して利用する者の利用目的</p>
            <p className='paragraph'>上記2に記載のとおり。</p>

            <p className='paragraph'>
              ■当該個人データの管理について責任を有する者の名称等
            </p>
            <div className='paragraph-group'>
              <p>・上記2の【採用・募集活動応募者様の個人情報】に関するもの</p>
              <p>株式会社エフ・ディ・シィ・プロダクツ</p>
              <p>〒141-8544 東京都品川区上大崎二丁目19-10</p>
              <p>代表取締役 岡藤 一朗</p>
              <p className='mt-2'>
                ・上記2の【採用・募集活動応募者様の個人情報】以外に関するもの
              </p>
              <p>株式会社ヨンドシーホールディングス</p>
              <p>〒141-0021 東京都品川区上大崎二丁目19-10</p>
              <p>代表取締役 増田 英紀</p>
            </div>
          </div>

          <div className='section'>
            <h2 className='section-title'>
              個人情報の開示、変更、削除等について
            </h2>
            <p className='paragraph'>
              ご自身の個人情報の開示、変更、削除、利用停止及び第三者への提供の停止、並びにご自身の個人情報に関する第三者提供記録の開示を希望される場合には、当社所定の手続に基づきご本人確認をさせていただいた上で、速やかに開示、変更、削除、利用停止及び第三者への提供の停止をさせていただきます。後記9記載のお問い合わせ先にご連絡ください｡
              なお、個人情報の削除、利用停止、第三者への提供の停止により、それまでご利用可能であったサービスを提供することができなくなる場合がありますので、あらかじめご了承の上ご請求ください。
            </p>
          </div>

          <div className='section'>
            <h2 className='section-title'>第三者への提供について</h2>
            <p className='paragraph'>
              当社は、ご本人からの承諾なしに、個人情報を第三者に提供することはいたしません。
              ただし、以下のような場合には、例外として個人情報を提供することがあります。
            </p>
            <div className='paragraph-group'>
              <p>■法令に基づき提供を求められた場合</p>
              <p>
                ■当社、当社従業員及びお客様その他の第三者の権利または財産が侵害されるおそれがあると当社が判断した場合
              </p>
              <p>
                ■公衆衛生の向上又は児童の健全な育成の推進のために提供が必要であると当社が判断した場合
              </p>
              <p>
                ■ご本人に明示した利用目的の達成に必要な範囲で個人情報の取扱いを委託する場合
              </p>
              <p>■上記4に記載のとおり共同して利用する場合</p>
            </div>
          </div>

          <div className='section'>
            <h2 className='section-title'>社内体制について</h2>
            <p className='paragraph'>
              当社は、従業員に対して社内教育を実施し、個人情報保護についての意識の向上と定期的な内部監査の実施により、個人情報の適正な管理に努めます。
            </p>
          </div>

          <div className='section'>
            <h2 className='section-title'>
              法令の遵守と個人情報の取扱いの改善について
            </h2>
            <p className='paragraph'>
              当社は、個人情報の保護に関する法律その他個人情報の取扱いにおいて適用される法令、を遵守するとともに、本ポリシー及び個人情報の取扱いについて、継続的改善を図ってまいります。
            </p>
          </div>

          <div className='section'>
            <h2 className='section-title'>個人情報に関するお問い合わせ先</h2>
            <p className='paragraph'>
              当社による個人情報の取扱いに関するご意見、ご質問などは下記までお問い合わせください。
              (株)エフ・ディ・シィ・プロダクツ 総務課
            </p>
            <p className='email'>
              E-mail: <a href='mailto:privacy@fdcp.co.jp'>privacy@fdcp.co.jp</a>
            </p>
          </div>

          <div className='section'>
            <h2 className='section-title'>
              個人を特定しない属性情報・行動履歴の取得及び利用について
            </h2>
            <p className='paragraph'>
              当ウェブサイトでは、広告配信事業者が提供するプログラムを利用し、
              特定のサイトにおいて行動ターゲティング広告（サイト閲覧情報などをもとにお客様の興味・関心にあわせて広告を配信する広告手法）を行っております。
              その際、お客様のサイト訪問履歴情報を採取するためCookieを使用しています。
              広告配信事業者は
              当該Cookieを使用して当ウェブサイトへの過去のアクセス情報に基づいて広告を配信します。
              この広告の無効化を希望されるお客様は
              広告配信事業者のオプトアウトページにアクセスして、Cookie
              の使用を無効にできます。
              ブラウザの変更、Cookieの削除及び新しいPCへ変更等の場合には再度設定が必要となります。
              お客様は広告配信事業者のオプトアウトページでYahoo!やGoogleのCookie
              を使用しないよう設定できます。 また、Network Advertising
              Initiative のオプトアウト ページでも第三者配信事業者の Cookie
              の使用を無効にできます。
              オプトアウトを行っていない場合、Yahoo!やGoogle他、第三者広告配信事業者または広告ネットワークの
              Cookie も使用される可能性があります。 Network Advertising
              Initiative のオプトアウト
              ウェブサイトでは、一部のCookie（すべてではありません）をまとめて無効にできます。
            </p>

            <h2 className='sub-title'>
              ・オプトアウトページのURLは下記になります。
            </h2>
            <div className='paragraph-list'>
              <p>Yahoo!のオプトアウトページ：</p>
              <a href='http://btoptout.yahoo.co.jp/optout/preferences.html'>
                http://btoptout.yahoo.co.jp/optout/preferences.html
              </a>

              <p className='mt-2'>Googleのオプトアウトページ：</p>
              <a href='https://support.google.com/ads/answer/2662922?hl=ja'>
                https://support.google.com/ads/answer/2662922?hl=ja
              </a>

              <p className='mt-2'>
                Network Advertising Initiativeのオプトアウトページ：
              </p>
              <a href='http://www.networkadvertising.org/choices/#completed'>
                http://www.networkadvertising.org/choices/#completed
              </a>
            </div>
          </div>

          <div className='section'>
            <h2 className='section-title'>Cookieについて</h2>
            <p className='paragraph'>
              Cookieとは、ウェブページを利用したときに、ブラウザとサーバーとの間で送受信した利用履歴や入力内容などをお客様のコンピュータに一時的にデータを書き込んで保存させる仕組みです。
            </p>
          </div>

          <div className='section'>
            <h2 className='section-title'>Cookieの設定について</h2>
            <p className='paragraph'>
              お客様はCookieの送受信に関する設定を「すべてのCookieを許可する」、「すべてのCookieを拒否する」、「Cookieを受信したらユーザーに通知する」などから選択できます。設定方法は、ブラウザにより異なります。
              Cookieに関する設定方法は、お使いのブラウザの「よくあるご質問」メニューでご確認ください。
            </p>
          </div>

          <div className='section'>
            <h2 className='section-title'>本ポリシーの変更について</h2>
            <p className='paragraph'>
              当社は、本ポリシーを変更させていただく場合があります。この場合、当社は、変更後の本ポリシーを当ウェブサイト上にて掲載いたしますが、当該掲載時点から変更後の本ポリシーが適用されるものとします。最新の内容をよくご確認いただきますようお願いいたします。
            </p>
            <div className='paragraph-list'>
              <p>株式会社エフ・ディ・シィ・プロダクツ</p>
              <p>〒141-8544 東京都品川区上大崎二丁目19-10</p>
              <p>代表取締役 岡藤 一朗</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyViewPage;
